import { formatTinNumber } from '../../../../../../utils/tin-number-formater.utils';
import { Affiliation, ClientBasicInfoState } from '../../../../../../features/gms-proposal-forms/basic-information/basic-information.state';
import Selection from './selection';

interface Props {
    info: ClientBasicInfoState,
    affiliations: Affiliation[]
    natureOfBusinessItem: string | undefined
    companyContactNumberName: string | undefined
    companyContactNumberType: number | undefined
    contactPersonContactName: string | undefined
    contactPersonContactType: number | undefined
}

export default function BasicInfoReview({ info, affiliations, natureOfBusinessItem, companyContactNumberName, companyContactNumberType, contactPersonContactName, contactPersonContactType }: Props) {

    const salutation = info?.contactPersonSalutation
    const firstName = info?.contactPersonFirstName 
    const middleName = info?.contactPersonMiddleName 
    const lastName = info?.contactPersonLastName 
    const middleInitial = middleName ? `${middleName.charAt(0)}.` : '';

    const tinNumber = info.tinNumber.length > 0 ? info.tinNumber : '-'
    const secNumber = info.secNumber.length > 0 ? info.secNumber : '-'
    const companyNumber = secNumber || tinNumber
    
    const companyMobileNumber = info.companyMobileNo === '' ? '' : `+63${info.companyMobileNo}`;
    const companyTelephoneNumber = info.companyTelephone === '' ? '' : info.companyTelephone;
    const companyContactNumber = companyMobileNumber || companyTelephoneNumber
    // const companyContactNumberFinal = companyContactNumber.length > 0 ? companyContactNumber : '-'
    const companyContactNumberFinal =
    companyContactNumberType === 66
        ? info.companyMobileNo?.trim()
            ? `+63${info.companyMobileNo}`
            : "-"
        : info.companyTelephone?.trim()
            ? info.companyTelephone
            : "-";

    // const contactPersonContactName = useSelector(selectBasicInformationContactPersonNumberName)
    // const contactPersonContactType = useSelector(selectBasicInformationContactPersonNumberId)
    const contractPersonFormat = `${salutation ?? ''} ${firstName ?? ''} ${middleInitial} ${lastName ?? ''}`.replace(/\s+/g, ' ').trim();
    const contactPersonMobileNumber = info?.contactNumber === '' ? '' : `+63${info?.contactNumber}`;
    const contactPersonTelephoneNumber = info?.contactTelephone === '' ? '' : info?.contactTelephone;
    const contactPersonNumber = contactPersonMobileNumber || contactPersonTelephoneNumber
    // const contactPersonNumberFinal = contactPersonNumber.length > 0 ? contactPersonNumber : '-'
    const contactPersonNumberFinal =
    contactPersonContactType === 66
        ? info.contactNumber?.trim()
            ? `+63${info?.contactNumber}`
            : "-"
        : info?.contactTelephone?.trim()
            ? info?.contactTelephone
            : "-";
    
    const hasAffiliations = affiliations.some(({ id, ...rest }) =>
        Object.values(rest).some(
            (value) => value !== "" && value !== null && value !== undefined
        )
    );
    return (
        <div className="space-y-5">
            {/* ================================================= */}
            {/* COMPANY INFORMATION */}
            {/* ================================================= */}
            <div className="overflow-hidden rounded-lg border border-gray-200">
                <div className="border-b border-gray-200 bg-gray-50 px-3 py-2">
                    <h3 className="text-[11px] font-semibold uppercase tracking-wide text-gray-600">
                        Company Information
                    </h3>
                </div>
                <div className="p-3 sm:p-4">
                    <div className="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                        <Selection
                            labelTitle="SEC Registered Name"
                            labelName={info.groupName ?? "-"}
                        />
                        <Selection
                            labelTitle="Nature of Business"
                            labelName={natureOfBusinessItem ?? "-"}
                        />
                        <Selection
                            labelTitle="No. of Lives"
                            labelName={String(info.noOfLives) ?? "-"}
                        />
                        <Selection
                            labelTitle="Complete Business Address"
                            labelName={info.completeBusinessAddress ?? "-"}
                        />
                        <Selection
                            labelTitle="Proposal Addressee"
                            labelName={info.proposalAddress ?? "-"}
                        />

                        <Selection
                            labelTitle="Addressee Designation"
                            labelName={info.addressDesignation ?? "-"}
                        />
                        <Selection
                            labelTitle="TIN Number"
                            labelName={tinNumber ?? "-"}
                        />
                        <Selection
                            labelTitle="SEC Number"
                            labelName={secNumber ?? "-"}
                        />
                        <Selection
                            labelTitle={`Company ${companyContactNumberName} No.`}
                            labelName={companyContactNumberFinal ?? "-"}
                        />
                    </div>
                </div>
            </div>
            {/* ================================================= */}
            {/* CONTACT PERSON */} 
            {/* ================================================= */}
            <div className="overflow-hidden rounded-lg border border-gray-200">
                <div className="border-b border-gray-200 bg-gray-50 px-3 py-2">
                    <h3 className="text-[11px] font-semibold uppercase tracking-wide text-gray-600">
                        Contact Person
                    </h3>
                </div>
                <div className="p-3 sm:p-4">
                    <div className="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-4">
                        <Selection
                            labelTitle="Full Name"
                            labelName={contractPersonFormat ?? "-"}
                        />
                        <Selection
                            labelTitle={`${contactPersonContactName} Number`}
                            labelName={contactPersonNumberFinal ?? "-"}
                        />
                        <Selection
                            labelTitle="Email"
                            labelName={info.email ?? "-"}
                        />
                        <Selection
                            labelTitle="Designation"
                            labelName={info.designation ?? "-"}
                        />
                    </div>
                </div>
            </div>
            {/* ================================================= */}
            {/* AFFILIATED COMPANIES */}
            {/* ================================================= */}
            <div className="overflow-hidden rounded-lg border border-gray-200">
                <div className="border-b border-gray-200 bg-gray-50 px-3 py-2">
                    <h3 className="text-[11px] font-semibold uppercase tracking-wide text-gray-600">
                        Affiliated Companies
                    </h3>
                </div>
                {hasAffiliations ? (
                    <div className="overflow-x-auto">
                        <table className="w-full min-w-[600px] border-collapse text-xs">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border border-gray-200 px-3 py-2 text-left text-[11px] font-semibold text-gray-600">
                                        Affiliation Name
                                    </th>
                                    <th className="border border-gray-200 px-3 py-2 text-left text-[11px] font-semibold text-gray-600">
                                        Address
                                    </th>
                                    <th className="border border-gray-200 px-3 py-2 text-left text-[11px] font-semibold text-gray-600">
                                        TIN Number
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {affiliations.map((item) => (
                                    <tr
                                        key={item.id}
                                        className="transition hover:bg-gray-50"
                                    >
                                        <td className="max-w-[280px] break-words border border-gray-200 px-3 py-2 text-xs text-gray-700">
                                            {item.name || "-"}
                                        </td>
                                        <td className="max-w-[400px] break-words border border-gray-200 px-3 py-2 text-xs text-gray-700">
                                            {item.address || "-"}
                                        </td>
                                        <td className="border border-gray-200 px-3 py-2 text-xs text-gray-700">
                                            {item.tinNumber?.toString().trim() ? formatTinNumber(item.tinNumber) : "-"}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="bg-gray-50 px-3 py-3 text-xs text-gray-500">
                        No affiliated companies added.
                    </div>
                )}
            </div>
        </div>
    )
}
